import React from 'react';
import Select from 'react-select';
import {components} from 'react-select';
import {ReactComponent as FilterMenu} from "resources/images/fillter-menu.svg";
import {colors} from "constants/colors";
import {useTheme} from "react-jss";

// Custom Dropdown Indicator (Icon Button)
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <FilterMenu/>
    </components.DropdownIndicator>
  );
};

const CustomValueContainer = (props) => {
  return <components.ValueContainer {...props} />;
};

const FilterMenuSelect = (props) => {
  const {value, onChange, className, options, disabled} = props;

  const theme = useTheme();

  return (
    <Select
      className={className}
      value={value}
      onChange={onChange}
      options={options}
      components={{
        DropdownIndicator,
        ValueContainer: CustomValueContainer,
        IndicatorSeparator: () => null,
      }}
      placeholder={null}
      isSearchable={false}
      isDisabled={disabled}
      styles={{
        container: (provided) => ({
          ...provided,
          margin: 'auto 0'
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          padding: 0,
          position: "absolute"
        }),
        control: (provided, {menuIsOpen}) => ({
          ...provided,
          cursor: 'pointer',
          borderRadius: '4px',
          padding: '10px',
          backgroundColor: disabled ? theme.buttons.default.hover.backgroundColor : menuIsOpen ? colors.brightBlue : colors.white,
          border: menuIsOpen ? "1px solid transparent" : theme.buttons.default.border,
          boxShadow: "none",
          "&:focus": {
            color: theme.buttons.default.color,
            backgroundColor: theme.buttons.default.hover.backgroundColor,
          },
          "&:hover": {
            backgroundColor: theme.buttons.default.hover.backgroundColor,
          },
        }),
        menu: (provided) => ({
          ...provided,
          marginTop: '0',
          borderRadius: '4px',
          position: 'absolute',
          right: 0,
          top: '48px',
          width: 'max-content',
          minWidth: '96px',

        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: '0',
        }),
        menuList: () => ({
          padding: "4px"
        }),
        option: (provided, {isFocused, isSelected}) => ({
          ...provided,
          backgroundColor: isFocused || isSelected ? colors.white : undefined,
          color: isFocused || isSelected ? colors.grey : undefined,
          cursor: "pointer",
          "&:hover": {
            color: colors.grey,
            backgroundColor: colors.brightBlue,
            borderRadius: "8px"
          },
        })
      }}
    />
  );
};

export default FilterMenuSelect;
